import {
  ResponseAchievementsType,
  cldBookForAchievementsType,
} from '@/@types/achievements'
import {
  cldBookForRevisionAchievementsType
} from '@/@types/achievements/revision_2024'
import { CsvRebillingCldInfo, CsvRevisionRebillingCldInfo } from '@/@types/children'
import { defineObject } from '@/lib/define/use-define'
import {
  getSessionStorageChildData,
} from '@/lib/sessionStrage/revision_2024/re-billing-utils'


const getRemarksTextKasanExtendedText = (
  targetAchievements: ResponseAchievementsType
): string => {
  let text = ''

  const activeExtendedValueArray = defineObject.KASAN_EXTENDED_INPUT_ARRAY.filter(
    item => item.value !== '0'
  ).map(item => item.value)

  const kasanExtendedValue = activeExtendedValueArray.includes(
    targetAchievements.kasan_extended
  )
    ? targetAchievements.kasan_extended
    : activeExtendedValueArray.includes(
        targetAchievements.jihatsu_kasan_extended
      )
    ? targetAchievements.jihatsu_kasan_extended
    : '0'

  if (kasanExtendedValue !== '0') {
    const kasanExtendedText = defineObject.KASAN_EXTENDED_INPUT_ARRAY.find(
      item => item.value === kasanExtendedValue
    )?.label

    text = kasanExtendedText ? ` 延長支援加算 ${kasanExtendedText}` : ''
  }

  return text
}

const getRevisionRemarksTextKasanExtendedText = (
  targetAchievements: ResponseAchievementsType
): string => {
  let text = ''

  const activeExtendedValueArray = defineObject.KASAN_NEW_EXTENDED_INPUT_ARRAY.filter(
    item => item.value !== '0'
  ).map(item => item.value)

  const kasanExtendedValue = activeExtendedValueArray.includes(
    targetAchievements.kasan_extended
  )
    ? targetAchievements.kasan_extended
    : activeExtendedValueArray.includes(
        targetAchievements.jihatsu_kasan_extended
      )
    ? targetAchievements.jihatsu_kasan_extended
    : '0'

  if (kasanExtendedValue !== '0') {
    const kasanExtendedText = defineObject.KASAN_NEW_EXTENDED_INPUT_ARRAY.find(
      item => item.value === kasanExtendedValue
    )?.label

    text = kasanExtendedText ? ` 延長支援加算 ${kasanExtendedText}` : ''
  }

  return text
}

const getRemarksTextKasanStrengthText = (
  targetAchievements: ResponseAchievementsType
): string => {
  let text = ''

  const kasanStrengthValue =
    targetAchievements.kasan_strength === '1'
      ? targetAchievements.kasan_strength
      : targetAchievements.jihatsu_kasan_strength === '1'
      ? targetAchievements.jihatsu_kasan_strength
      : '0'

  text = kasanStrengthValue === '1' ? ' 強度行動障害児支援加算 あり' : ''

  return text
}

export const setDefaultKasanStrengthOfCsvRebilling = (
  noteInfoObject: cldBookForAchievementsType,
  billingCldInfo: CsvRebillingCldInfo
): cldBookForAchievementsType => {
  switch (noteInfoObject.affiliation) {
    case '0':
      if (billingCldInfo.kasan_strength === '1')
        noteInfoObject.kasanStrength = '1'
      break

    case '1':
      if (billingCldInfo.jihatsu_kasan_strength === '1')
        noteInfoObject.jihatsuKasanStrength = '1'
      break
  }

  return noteInfoObject
}

export const setDefaultKasanStrengthOfRevisionCsvRebilling = (
  noteInfoObject: cldBookForAchievementsType,
  billingCldInfo: CsvRevisionRebillingCldInfo
): cldBookForAchievementsType => {
  switch (noteInfoObject.affiliation) {
    case '0':
      if (billingCldInfo.kasan_kyodo_kodo === '1' || billingCldInfo.kasan_kyodo_kodo === '2')
        noteInfoObject.kasanStrength = '1'
      break

    case '1':
      if (billingCldInfo.jihatsu_kasan_strength === '1')
        noteInfoObject.jihatsuKasanStrength = '1'
      break
  }

  return noteInfoObject
}

export const setDefaultKasanKinoShogaijiOfCsvRebilling = (
  noteInfoObject: cldBookForRevisionAchievementsType,
  billingCldInfo: CsvRevisionRebillingCldInfo
): cldBookForRevisionAchievementsType => {
  switch (noteInfoObject.affiliation) {
    case '0':
      if (billingCldInfo.kasan_kino_shogaiji === '1')
        noteInfoObject.kasanKinoShogaiji = '1'
      break

    case '1':
      if (billingCldInfo.jihatsu_kasan_kino_shogaiji === '1')
        noteInfoObject.jihatsuKasanKinoShogaiji = '1'
      break
  }

  return noteInfoObject
}

export const setDefaultKasanTsusyoJiritsuOfCsvRebilling = (
  noteInfoObject: cldBookForRevisionAchievementsType,
  billingCldInfo: CsvRevisionRebillingCldInfo
): cldBookForRevisionAchievementsType => {
  switch (noteInfoObject.affiliation) {
    case '0':
      if (billingCldInfo.kasan_tsusho_jiritsu === '1')
        noteInfoObject.kasanTsushoJiritsu = '1'
      break

  }

  return noteInfoObject
}


export const setAchivementsRemarks = (
  setRemarks: unknown,
  targetAchievements: ResponseAchievementsType
): string => {
  let remarks = ''

  if (setRemarks) {
    remarks = String(setRemarks)
  }

  const remarksTextKasanExtendedText = getRemarksTextKasanExtendedText(
    targetAchievements
  )

  const remarksTextKasanStrengthText = getRemarksTextKasanStrengthText(
    targetAchievements
  )

  remarks =
    remarks + remarksTextKasanExtendedText + remarksTextKasanStrengthText

  return remarks
}

export const setRevisionAchivementsRemarks = (
  setRemarks: unknown,
  targetAchievements: ResponseAchievementsType
): string => {
  let remarks = ''

  if (setRemarks) {
    remarks = String(setRemarks)
  }

  const remarksTextKasanExtendedText = getRevisionRemarksTextKasanExtendedText(
    targetAchievements
  )

  const remarksTextKasanStrengthText = getRemarksTextKasanStrengthText(
    targetAchievements
  )

  remarks =
    remarks + remarksTextKasanExtendedText + remarksTextKasanStrengthText

  return remarks
}

export const getShapePreSetAchievementsOfCsvRebilling = (
  achievements: ResponseAchievementsType
): ResponseAchievementsType => {
  if (!achievements) return achievements

  achievements.remarks = setAchivementsRemarks(
    achievements.remarks,
    achievements
  )

  return achievements
}

export const setDefaultVisitKasanOfCsvRebilling = (
  props: any,
  state: any,
) => {
  const childData = getSessionStorageChildData()
  const targetChildData = childData.filter((child: {[key: string]: string}) => child.id === props.cldId)
  if(targetChildData.lenght !== 0) {
    state.noteParam.dataObject.visitKasanCareNeeds =
      targetChildData[0].visit_kasan_care_needs === '1' ? targetChildData[0].visit_kasan_care_needs : '0'

    state.noteParam.dataObject.visitKasanStrength =
      targetChildData[0].visit_kasan_strength === '1' ? targetChildData[0].visit_kasan_strength : '0'
  }


}
